import { Api } from './axios-config';

export interface IWeeklyScheduleDay {
  id: number;
  businessId?: number;
  businessEmployeeId?: number;
  dayOfWeek: number;
  dayName: string;
  isClosed: boolean;
  startTime?: string | null;
  endTime?: string | null;
}

export interface IBusinessHoliday {
  id: number;
  businessId: number;
  date: Date;
  description: string;
}

const getHolidays = async (businessId: number): Promise<IBusinessHoliday[]> => {
  const { data } = await Api.get<IBusinessHoliday[]>(`/business-holiday/${businessId}`);
  return data;
};

const addHoliday = async (businessId: number, date: Date, description: string): Promise<IBusinessHoliday> => {
  const { data } = await Api.post<IBusinessHoliday>(`/business-holiday/${businessId}`, { businessId, date, description });
  return data;
};

const removeHoliday = async (businessId: number, id: number): Promise<void> => {
  await Api.delete(`/business-holiday/${businessId}/${id}`);
};

export const businessHolidayService = {
  getHolidays,
  addHoliday,
  removeHoliday,
};
